export default __webpack_public_path__ + "static/media/gallery_02.9c9cb0bb.jpg";